import React from "react";
import { auth } from "../firebase_config";
import { Container } from "./reusable_components";
import Universe from "./Universe";

const PageNotFound = () => {
  return (
    <Container
      className="d-flex justify-center align-center"
      style={{ minHeight: "100vh" }}
    >
      <h1 style={{ color: "#fff", textAlign: "center" }}>
        The page you are looking, <br /> Doesn't exit <br />{" "}
        {auth.currentUser !== null && (
          <button
            onClick={() => {
              auth.signOut();
              window.location.reload();
            }}
          >
            Sign Out
          </button>
        )}
      </h1>
      <Universe />
    </Container>
  );
};

export default PageNotFound;
